(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("header");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.style.backgroundColor = 'rgb(0,0,0, 1 )'
  } else {
    header.style.backgroundColor = 'rgb(0,0,0, 0)';
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-menu"]) return;
  try {
    

$("a.drawer-nav__link").click(function() {
  $( ".js-drawer-close" ).trigger( "click" );
    console.log("closed");
  });

  } catch(e) { console.error(e); }
})();
})();
